module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/228-nauru-6ba1d5b7eea6ee6697e2c0001c5717d6.svg";